import { CombinedLogoOptions } from '../types';
import { fetchWithErrorHandling, guestPrefix } from './apiUtils';

export class LogoService {
  static async getLogoOptions(productId: number, color?: string | null, signal?: AbortSignal): Promise<CombinedLogoOptions> {
    try {
      const params = color ? `?color=${encodeURIComponent(color)}` : '';
      return await fetchWithErrorHandling<CombinedLogoOptions>(`/api/v2${guestPrefix()}/products/${productId}/logo-options${params}`, signal ? { signal } : undefined);
    } catch (error) {
      if (error instanceof DOMException && error.name === 'AbortError') return { primary: [], secondary: [] };
      console.error('Failed to fetch logo options:', error);
      return { primary: [], secondary: [] };
    }
  }
}
